export default "__VITE_ASSET__CCR3$IJi__"